export default {
  setLoading(state, value) {
    state.isLoading = value;
  },
  setData(state, {
    data,
    meta,
  }) {
    state.data = data;
    state.meta = meta;
  },
  setError(state, value) {
    state.hasError = value;
  },
  setTasks(state, tasks) {
    state.tasks = tasks;
  },
  updateTask(state, task) {
    if (state.tasks.length > 0) {
      const matchingTask = state.tasks.find(it => it.id === task.id);

      if (matchingTask) Object.assign(matchingTask, task);
    }
  },
  addTask(state, task) {
    if (!state.tasks || state.tasks.length === 0) {
      state.tasks = [];
    }
    state.tasks.push(task);
  },
  removeTask(state, taskId) {
    const removalIndex = state.tasks.findIndex(it => it.id === taskId);

    state.tasks.splice(removalIndex, 1);
  },
};
